import {useEffect, useState} from 'react'
import {LoadingSpinner} from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import {useLazyQuery} from '@apollo/client'
import useLazyQueryApi from '../../../../../../hooks/useLazyQuery'
import {
  GET_MATCHED_DOCTOR_LIST,
  GET_PATIENT_LIST_SEARCH,
} from '../../../../PharmaModule/GraphQLQueries/querys'
import useMutationApi from '../../../../../../hooks/useMutation'
import {ADD_PATIENT_TO_PHARMACY} from '../../../../PharmaModule/GraphQLQueries/mutation'
import './appointment.css'
import {PatientInfoType} from './types/patientDataType'
import { ToastMessageContainer } from '../../../../../../_ePulse/layout/components/ToastMessageContainer'

interface Suggestion {
  firstName: string
  lastName: string
  mobileNumber: string
  [key: string]: any
}

const AddPatient = (props: any) => {
  const [patientList, setPatientList] = useState<Suggestion[]>([])
  const [doctorSuggestions, setDoctorSuggestions] = useState<Suggestion[]>([])
  const [isFocused, setIsFocused] = useState(false)
  const [isDocotorFocused, setIsDoctorFocused] = useState(false)
  const [loading, setLoading] = useState(false)
  const [firstNameError, setFirstNameError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [doctorNameError, setDoctorNameError] = useState('')
  const [doctorPhoneError, setDoctorPhoneError] = useState('')
  const [patientPhoneNumber, setPatientPhoneNumber] = useState('')
  const [doctorPhoneNumber, setDoctorPhoneNumber] = useState('')
  const [patientName, setPatientName] = useState('')
  const [patientGender, setPatientGender] = useState('')
  const [doctorSpeciality, setDoctorSpeciality] = useState('')
  const [doctorName, setDoctorName] = useState('')

  const [patientInfo, setPatientInfo] = useState<PatientInfoType | null>(null)
  const [genderError, setGenderError] = useState('')

  //Graphql API call
  const {
    fetchData: fetchPatient,
    loading: patientLoading,
    error: patientError,
    data: patientData,
  } = useLazyQueryApi(true, GET_PATIENT_LIST_SEARCH)
  const {
    fetchData: fetchDoctor,
    loading: doctorLoading,
    error: doctorError,
    data: doctorData,
  } = useLazyQueryApi(true, GET_MATCHED_DOCTOR_LIST)
  const {
    createData: AddPatient,
    loading: loadingPatient,
    error: error,
    data: data,
  } = useMutationApi(ADD_PATIENT_TO_PHARMACY)

  const handlePatientPhoneChange = async (search: string) => {
    if (search.length > 10) return

    setPatientPhoneNumber(search)
    updatePatientInfo('patientNumber', search)

    if (search.length >= 3) {
      try {
        await fetchPatient({searchString: search})
      } catch (error) {
        console.error(error)
      }
    } else {
      setPatientList([])
    }
  }

 const updatePatientInfo = (field: keyof PatientInfoType, value: any) => {
    setPatientInfo((prev) => {
      const defaultPatientInfo: PatientInfoType = {
        patientRoleId:'',
        doctorRoleId:'',
        patientName: '',
        patientId: '',
        patientNumber: '',
        doctorName: '',
        doctorNumber: '',
        doctorId: '',
        specialty: '',
        patientGender: '',
      }
      return {
        ...(prev ?? defaultPatientInfo),
        [field]: value,
      }
    })
  }

  useEffect(() => {
    if (patientGender) {
      updatePatientInfo('patientGender', patientGender)
    }
  }, [patientGender])

  useEffect(() => {
    if (patientData && patientData.getPatientListSearch) {
      setPatientList(patientData.getPatientListSearch)
    }
  }, [patientData])

  const handleSuggestionClick = (suggestion: any) => {
    setIsFocused(false)
    setPatientName(`${suggestion.firstName} ${suggestion.lastName}`)
    setPatientPhoneNumber(suggestion.mobileNumber)
    setPatientGender(suggestion.gender)
    updatePatientInfo('patientNumber', suggestion.mobileNumber)
    updatePatientInfo('patientName', `${suggestion.firstName} ${suggestion.lastName}`)
    updatePatientInfo('patientId', suggestion.userId)
    updatePatientInfo('patientRoleId', suggestion.userRoleId)
  }

  const checkPatientValidation = (phone: string, patName: string) => {
    let isValid = true
    const trimmedName = patName.trim()
    const trimmedPhone = phone.trim()

    // Name validation
    if (!trimmedName) {
      setFirstNameError('Full name is required!')
      isValid = false
    } else if (trimmedName.length < 2) {
      setFirstNameError('Full name must be at least 2 characters!')
      isValid = false
    } else if (!/^[a-zA-Z ]+/.test(trimmedName)) {
      setFirstNameError('Full name can only contain letters!')
      isValid = false
    } else {
      setFirstNameError('')
    }

    // Phone validation
    if (!trimmedPhone) {
      setPhoneError('Phone number is required!')
      isValid = false
    } else if (!/^\d{10}$/.test(trimmedPhone)) {
      setPhoneError('Phone number must be 10 digits!')
      isValid = false
    } else {
      setPhoneError('')
    }

    return isValid
  }

  const handlePatientNameChange = (value: any) => {
    setPatientName(value.trim())
    if (!value.trim()) {
      setFirstNameError('Full name is required!')
    } else {
      setFirstNameError('')
    }
  }

  // Doctor Search
  const handleDoctorPhoneChange = async (search: string) => {
    if (search.length > 10) return

    setDoctorPhoneNumber(search)
    updatePatientInfo('doctorNumber', search)

    if (search.length >= 3) {
      try {
        await fetchDoctor({searchString: search})
      } catch (error) {
        console.error(error)
      }
    } else {
      setDoctorSuggestions([])
    }
  }

  useEffect(() => {
    if (doctorData && doctorData?.getDoctorSearchList) {
      setDoctorSuggestions(doctorData?.getDoctorSearchList)
    }
  }, [doctorData])

  const handleDoctorSuggestionClick = (suggestion: any) => {
    setDoctorName(`${suggestion.firstName} ${suggestion.lastName}`)
    setDoctorPhoneNumber(suggestion.mobileNumber)
    setIsDoctorFocused(false)
    updatePatientInfo('doctorNumber', suggestion.mobileNumber)
    updatePatientInfo('doctorName', `${suggestion.firstName} ${suggestion.lastName}`)
    updatePatientInfo('doctorId', suggestion.userId)
    updatePatientInfo('doctorId', suggestion.userId)
    updatePatientInfo('specialty', suggestion.specialty)
    updatePatientInfo('doctorRoleId', suggestion.userRoleId)
  }
  const handleDoctorNameChange = (value: any) => {
    setDoctorName(value)
    if (!value) {
      setDoctorNameError('Full name is required!')
    } else {
      setDoctorNameError('')
    }
  }

  const addPatient = async () => {
    setLoading(true)
    setIsFocused(false)
    setIsDoctorFocused(false)

    const isValid = checkPatientValidation(patientPhoneNumber, patientName)
    const isGenderValid = validateGender()

    if (!isValid || !isGenderValid) {
      setLoading(false)
      return
    }

    try {
      await AddPatient({
        patientInput: {
          mobileNumber: patientPhoneNumber,
          firstName: patientName,
          lastName: patientName,
          countryCode: 91,
        },
      })

      if (props.onPatientInfo && patientInfo) {
        props.onPatientInfo(patientInfo)
      }

      props.handleStep(2)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const validateGender = () => {
    if (!patientGender || (patientGender !== 'Male' && patientGender !== 'Female' && patientGender !== 'Other')) {
      setGenderError('Please select a valid gender.')
      return false
    }
    setGenderError('')
    return true
  }

  return (
    <div className='patient-box'>
      <ToastMessageContainer/>
      <LoadingSpinner isLoading={patientLoading || doctorLoading || loadingPatient} />
      <div className='width-100 d-flex flex-row justify-content-between '>
        <div className='width-50 mb-3'>
          <span className='page-header' style={{marginLeft: 12}}>
            Add Patient
          </span>
          <div className='patient-box'>
            <span>Phone Number</span>
            <div className='input-group'>
              <input
                type='tel'
                value={patientPhoneNumber}
                placeholder='Enter at least 3 digits to search'
                onFocus={() => setIsFocused(true)}
                // onBlur={() => setIsFocused(false)}
                onChange={(e) => handlePatientPhoneChange(e.target.value)}
                className={`form-control px-3 ${phoneError ? 'is-invalid' : ''}`}
              />
              {isFocused && patientList?.length > 0 && (
                <div className='suggestions-list'>
                  {patientList.map((item) => (
                    <div
                      onClick={() => {
                        console.log('item', item)
                        handleSuggestionClick(item)
                        checkPatientValidation(
                          item.mobileNumber,
                          `${item.firstName} ${item.lastName}`
                        )
                      }}
                      className='suggestion-item'
                    >
                      <p>
                        <span className='product-name'>
                          {' '}
                          {item.firstName} {item.lastName}{' '}
                        </span>{' '}
                        <br />
                        <span className='batch-name'>{item.mobileNumber}</span>{' '}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {phoneError && <p style={{color: 'red', marginTop: -9}}>{phoneError}</p>}

            <span className='mt-2'>Full Name</span>
            <input
              type={'text'}
              value={patientName}
              placeholder='Enter full name'
              className={`form-control px-3 ${firstNameError ? 'is-invalid' : ''}`}
              onChange={(e) => handlePatientNameChange(e.target.value)}
            />
            {firstNameError && <p style={{color: 'red'}}>{firstNameError}</p>}
            <span className='mt-2'>Gender</span>
            <select
              className={`form-control px-3 ${genderError ? 'is-invalid' : ''}`}
              value={patientGender}
              onChange={(e) => {
                setPatientGender(e.target.value)
                updatePatientInfo('patientGender', e.target.value)
                setGenderError('') // Clear error on change
              }}
              onBlur={validateGender} // Validate on blur
            >
              <option value='' disabled>
                Select Gender
              </option>
              <option value='Male'>Male</option>
              <option value='Female'>Female</option>
              {/* <option value='Other'>Other</option> */}
            </select>
            {genderError && <div style={{color: 'red', marginTop: 10}}>{genderError}</div>}
          </div>
        </div>

        <div className='width-50 mb-3'>
          <span className='page-header' style={{marginLeft: 12}}>
            Add Doctor (Optional)
          </span>
          <div className='patient-box'>
            <span>Phone Number</span>
            <div className='input-group'>
              <input
                type='tel'
                value={doctorPhoneNumber}
                placeholder='Enter at least 3 digits to search'
                onFocus={() => setIsDoctorFocused(true)}
                //onBlur={() => setIsFocused(false)}
                onChange={(e) => handleDoctorPhoneChange(e.target.value)}
                className='form-control px-3'
              />
              {isDocotorFocused && doctorSuggestions.length > 0 && (
                <div className='suggestions-list'>
                  {doctorSuggestions.map((item) => (
                    <div
                      onClick={() => {
                        handleDoctorSuggestionClick(item)
                        // checkDoctorValidation(item.mobileNumber, `${item.firstName} ${item.lastName}`)
                      }}
                      className='suggestion-item'
                    >
                      <p>
                        <span className='product-name'>
                          {' '}
                          {item.firstName} {item.lastName}{' '}
                        </span>{' '}
                        <br />
                        <span className='batch-name'>{item.mobileNumber}</span>{' '}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* {doctorPhoneError && <p style={{color: 'red', marginTop: -9}}>{doctorPhoneError}</p>} */}

            <span className='mt-2'>Full Name</span>
            <input
              type={'text'}
              value={doctorName}
              placeholder='Enter full name'
              className='form-control px-3'
              onChange={(e) => handleDoctorNameChange(e.target.value)}
            />
            {/* {doctorNameError && <p style={{color: 'red'}}>{doctorNameError}</p>} */}
          </div>
        </div>
      </div>
      <div className='filter-row ePulse-divider justify-content-end'>
        <button className='ePulse-btn-primary' onClick={() => addPatient()}>
          Continue
        </button>
      </div>
    </div>
  )
}

export default AddPatient
